import api from '../services/api';
import { toast } from 'react-toastify';

/**
 * Download a CSV export from the given admin endpoint.
 * Passes `params` as query-string filters (honoring the current page filter state).
 * Creates a temporary <a> element, clicks it, then revokes the object URL.
 *
 * @param {string} endpoint  e.g. '/admin/exports/rides'
 * @param {object} params    e.g. { status: 'completed', startDate: '...', endDate: '...' }
 * @param {string} filename  e.g. 'rides.csv'
 */
export async function exportToCsv(endpoint, params, filename) {
  try {
    const response = await api.get(endpoint, {
      params,
      responseType: 'blob',
    });

    const url = URL.createObjectURL(new Blob([response.data], { type: 'text/csv;charset=utf-8;' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error('CSV export failed:', err);
    toast.error('Export failed. Please try again.');
  }
}
